export const brand = {
    zhName: '观心',
    enName: 'Mira',
    enSlogan: 'See Within',
    sourceLogoPath: 'design/mira-logo.png',
    webLogoPath: '/assets/brand/mira-logo.png',
    wechatLogoPath: '/assets/brand/mira-logo.png',
};
export function brandName(mode) {
    return mode === 'zh' ? brand.zhName : brand.enName;
}
